import { NgModule } from '@angular/core';
import { Routes, RouterModule, UrlSegment } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { AccessManagementComponent } from './components/access-management/access-management.component';
import { MasterGlossaryComponent } from './components/master-glossary/master-glossary.component';
import { ErrorComponent } from './common/shared-components/error/error.component';
import { MyHistoryComponent } from './components/my-history/my-history.component';
import { MyAnnotationsComponent } from './components/my-annotations/my-annotations.component';
import { MyBookmarkComponent } from './components/my-bookmark/my-bookmark.component';
import { AboutUsComponent } from 'src/app/components/about-us/about-us.component';
import { CopyrightComponent } from 'src/app/components/copyright/copyright.component';
import { HelpComponent } from 'src/app/components/help/help.component';
import { TermsAndConditionsComponent } from 'src/app/components/terms-and-conditions/terms-and-conditions.component';
import { PendingcontentComponent } from './components/pending-content/pendingcontent.component';
import { ConceptsStatementsComponent } from './components/concepts-statements/concepts-statements.component';
import { PendingContentAgreementComponent } from './components/pending-content-agreement/pending-content-agreement.component';
import { PendingContentAgreementCheckService } from './common/services/pending-content-agreement-check.service';
import { ClearSessionsService } from './common/services/clear-sessions.service';
import { LoginHomeComponent } from './components/Login/login-home/login-home.component';
import { AICPAComponent } from './components/aicpa/aicpa.component';
import { SupersededStandardsComponent } from './components/superseded-standards/superseded-standards.component';
import { CrossReferenceComponent } from './components/cross-reference/cross-reference.component';
import { PendingContentIntegerationComponent } from './components/pending-content-integeration/pending-content-integeration.component';
import { SearchComponent } from './components/search/search.component';
import { HelpRelatedExposureDraftsComponent } from './components/help-related-exposure-drafts/help-related-exposure-drafts.component';
import { HelpAnnotationsComponent } from './components/help/help-annotations/help-annotations.component';
import { HelpArchiveContentComponent } from './components/help/help-archive-content/help-archive-content.component';
import { HelpBasisforConclusionsComponent } from './components/help/help-basisfor-conclusions/help-basisfor-conclusions.component';
import { HelpBookmarksComponent } from './components/help/help-bookmarks/help-bookmarks.component';
import { HelpBrowsingComponent } from './components/help/help-browsing/help-browsing.component';
import { HelpCrossreferenceComponent } from './components/help/help-crossreference/help-crossreference.component';
import { HelpFeedbackComponent } from './components/help/help-feedback/help-feedback.component';
import { HelpGlossariesComponent } from './components/help/help-glossaries/help-glossaries.component';
import { HelpGotoComponent } from './components/help/help-goto/help-goto.component';
import { HelpJACContentComponent } from './components/help/help-jaccontent/help-jaccontent.component';
import { HelpPendingcontentComponent } from './components/help/help-pendingcontent/help-pendingcontent.component';
import { HelpPrintingComponent } from './components/help/help-printing/help-printing.component';
import { HelpSearchingComponent } from './components/help/help-searching/help-searching.component';
import { HelpXbrlfeatureComponent } from './components/help/help-xbrlfeature/help-xbrlfeature.component';
import { HelpSeccontentComponent } from './components/help/help-seccontent/help-seccontent.component';
import { HelpPendingcontentSystemComponent } from './components/help/help-pendingcontent-system/help-pendingcontent-system.component';
import { NoticeToConstituentsComponent } from './components/notice-to-constituents/notice-to-constituents.component';
import { PendingcontentsystemFAQComponent } from './components/pendingcontentsystem-faq/pendingcontentsystem-faq.component';
import { HelpAbouttheCodificationComponent } from './components/help/help-aboutthe-codification/help-aboutthe-codification.component';
import { HelpCopyAndPasteComponent } from  './components/help/help-copy-and-paste/help-copy-and-paste.component';
import { HelpDisplayoptionComponent } from './components/help/help-displayoption/help-displayoption.component';
import { HelpRelatedProposedAsusComponent } from './components/help/help-related-proposed-asus/help-related-proposed-asus.component';
import { HelpMyascComponent } from './components/help/help-myasc/help-myasc.component';
import { HelpMyhistoryComponent } from './components/help/help-myhistory/help-myhistory.component';
import { ConceptStatementsComponent } from './components/concept-statements/concept-statements.component';
import { HelpLocationComponent } from './components/help/help-location/help-location.component';
import { XbrldataComponent } from './components/xbrldata/xbrldata.component';
import { RouteGaurdService } from './common/services/route-gaurd.service';
import { TaxonomyelementreffileComponent } from './taxonomyelementreffile/taxonomyelementreffile.component';
import { RedisCacheManagementComponent } from './components/redis-cache-management/redis-cache-management.component';
import { InternalViewRouteGuardService } from './common/services/internal-view-route-guard.service';
import { InternalAdminViewRouteGuardService } from './common/services/internal-admin-view-route-guard.service';
import { PDFBackupLandingPageComponent } from './components/pdfbackup-landing-page/pdfbackup-landing-page.component';
import { PDFBackupGaurdService } from './common/services/PDF-Backup-guard.service';

const publicationRouteMatcher = (url: UrlSegment[]) => {
  if ((url.length >= 1 && url[0].path.match(/^[0-9]+$/gm)) ||
    (url.length >= 1 && url[0].path.split("-").length > 2 && url[0].path.split("-")[0].match(/^[0-9]+$/gm) && url[0].path.split("-")[1].match(/^[0-9]+$/gm) && (url[0].path.split("-")[2].match(/^[0-9]+$/gm) || url[0].path.split("-")[2].toUpperCase().match(/^S[0-9]+$/gm)))) {
    return {
      consumed: url
    };
  }
  return null;
}
export function aaaUrl(url: UrlSegment[]) {
  var urlConst = url.length ? url[0].path.toLowerCase() :"";
  return url.length > 0 && urlConst.includes('home&u') ? ({ consumed: url }) : null ;
}


const routes: Routes = [
  {
    path: "ASCpdfs", component: PDFBackupLandingPageComponent,
    canActivate: [PDFBackupGaurdService],
    data: {
      title: 'ASC PDFs'
    }
  },
  {
    path: "PdfBackupContent", component: PDFBackupLandingPageComponent,
    canActivate: [InternalViewRouteGuardService],
    data: {
      title: 'PDF BackUp Content'
    }
  },
  {
    path: 'Login',
    loadChildren: () => import('./components/Login/Login.module').then(m => m.LoginModule),
    data: {
      title: 'FASB Accounting Standards Codification®'
    }
  },
  {
    path: 'logout', component: LoginHomeComponent,
    canActivate: [ClearSessionsService]
  },
  {
    path: 'Home', component: HomeComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Codification'
    }
  },
  {
    component: HomeComponent,
    matcher: aaaUrl,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Codification'
    }
  },
  {
    path: 'MyHistory', component: MyHistoryComponent,
    canActivate: [InternalViewRouteGuardService],
    data: {
      title: 'My History'
    }
  },
  {
    path: 'myBookmarks', component: MyBookmarkComponent,
    canActivate: [InternalViewRouteGuardService],
    data: {
      title: 'My Bookmarks'
    }
  },
  {
    path: 'myAnnotations', component: MyAnnotationsComponent,
    canActivate: [InternalViewRouteGuardService],
    data: {
      title: 'My Annotations'
    }
  },
  {
    path: 'MasterGlossary', component: MasterGlossaryComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Master Glossary'
    }
  },
  {
    path: 'Error', component: ErrorComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Error Page '
    }
  },
  {
    path: "about-us", component: AboutUsComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'About'
    }
  },
  {
    path: "copy-right-ASCpdfs", component: CopyrightComponent,
    data: {
      title: 'FASB Codification Copyright Permission'
    }
  },
  {
    path: "copy-right", component: CopyrightComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'FASB Codification Copyright Permission'
    }
  },
  {
    path: "contact-us", component: HomeComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Contact Us'
    }
  },
  {
    path: "help", component: HelpComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Help'
    }
  },
  {
    path: "terms-and-conditions-ASCpdfs", component: TermsAndConditionsComponent,
    data: {
      title: 'Terms and Conditions'
    }
  },
  {
    path: "terms-and-conditions", component: TermsAndConditionsComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Terms and Conditions'
    }
  },
  {
    path: 'pendingcontentsystemagreement',
    component: PendingContentAgreementComponent,
    canActivate: [RouteGaurdService, PendingContentAgreementCheckService],
    data: {
      title: 'Pending Content System'
    }
  },

  {
    path: 'pendingcontentsystem',
    component: PendingcontentComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Pending Content System'
    },
  },
  {
    path: 'search',
    component: SearchComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'search'
    },
  },

  {
    path: 'pendingcontentintegeration',
    component: PendingContentIntegerationComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Pendingcontentintegeration'
    },
  },
  {
    path: 'conceptstatements',
    component: ConceptsStatementsComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Concepts Statements'
    },
  },
  {
    path: 'conceptsstatements',
    component: ConceptStatementsComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Concept Statements'
    },
  },
  {
    path: 'AccessManagement',
    component: AccessManagementComponent,
    canActivate: [InternalAdminViewRouteGuardService],
    data: {
      title: 'Access Management'
    }
  },
  {
    path: 'xbrldata',
    component: XbrldataComponent,
    canActivate: [InternalAdminViewRouteGuardService],
    data: {
      title: 'XBRL Elements'
    }
  },
  {
    path: 'aicpa',
    component: AICPAComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'AICPA Pre-Codification'
    }
  },
  {
    path: 'supersededstandards',
    component: SupersededStandardsComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Superseded Standards'
    }
  },
  {
    path: 'crossreference',
    component: CrossReferenceComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Cross Reference'
    }
  },
  {
    path: 'relatedproposedasus',
    component: HelpRelatedExposureDraftsComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Related Exposure ASUs'
    }
  },
  {
    path: 'help-annotations',
    component: HelpAnnotationsComponent,
    canActivate: [InternalViewRouteGuardService],
    data: {
      title: 'FASB Codification Annotations'
    }
  },
  {
    path: 'helparchivecontent',
    component: HelpArchiveContentComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'FASB Codification Archived Content'
    }
  },
  {
    path: 'helpbasisforconclusion',
    component: HelpBasisforConclusionsComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'FASB Codification Basis for Conclusions'
    }
  },
  {
    path: 'helpbookmarks',
    component: HelpBookmarksComponent,
    canActivate: [InternalViewRouteGuardService],
    data: {
      title: 'FASB Codification Bookmark'
    }
  },
  {
    path: 'helpbrowsing',
    component: HelpBrowsingComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'FASB Codification Browsing'
    }
  },
  {
    path: 'helpcrossreference',
    component: HelpCrossreferenceComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'FASB Codification Cross Reference'
    }
  },
  {
    path: 'helpfeedback',
    component: HelpFeedbackComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'help-feedback'
    }
  },
  {
    path: 'helpglossaries',
    component: HelpGlossariesComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'FASB Codification Glossaries'
    }
  },
  {
    path: 'helpgoto',
    component: HelpGotoComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'FASB Codification Go To'
    }
  },
  {
    path: 'helpshowall',
    component: HelpJACContentComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'FASB Codification Show All in One Page'
    }
  },
  {
    path: 'helppendingcontent',
    component: HelpPendingcontentComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'FASB Codification Pending Content'
    }
  },
  {
    path: 'helprintingcontent',
    component: HelpPrintingComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'FASB Codification Printing'
    }
  },
  {
    path: 'helpsearching',
    component: HelpSearchingComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'FASB Codification Searching'
    }
  },
  {
    path: 'helpxbrlfeature',
    component: HelpXbrlfeatureComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'FASB Codification XBRL Features'
    }
  },
  {
    path: 'helpseccontent',
    component: HelpSeccontentComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'FASB Codification SEC Content'
    }
  },
  {
    path: 'helppcs',
    component: HelpPendingcontentSystemComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'FASB Codification Pending Content System'
    }
  },
  {
    path: 'noticetoconstituents',
    component: NoticeToConstituentsComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'notice to constituents'
    }
  },
  {
    path: 'pcsfaq',
    component: PendingcontentsystemFAQComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'FASB Codification Pending Content System-Frequently Asked Questions'
    }
  },
  {
    path: 'helpcopyandpaste',
    component: HelpCopyAndPasteComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'help-copy and paste'
    }
  },
  {
    path: 'helplocation',
    component: HelpLocationComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'help-Location'
    }
  },
  {
    path: 'helpaboutthecodification',
    component: HelpAbouttheCodificationComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'FASB Codification About the Codification'
    }
  },
  {
    path: 'helprelatedproposedasus',
    component: HelpRelatedProposedAsusComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'FASB Codification Related Proposed Asus'
    }
  },
  {
    path: 'helpmyhistory',
    component: HelpMyhistoryComponent,
    canActivate: [InternalViewRouteGuardService],
    data: {
      title: 'FASB Codification My History'
    }
  },
  {
    path: 'helpmyasc',
    component: HelpMyascComponent,
    canActivate: [InternalViewRouteGuardService],
    data: {
      title: 'FASB Codification My Asc'
    }
  },
  {
    path: 'helpdisplayoption',
    component: HelpDisplayoptionComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'FASB Codification Display Option'
    }
  },
  {
    path: 'taxonomyelementsreferencefile',
    component: TaxonomyelementreffileComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Taxonomy Element Reference File'
    }
  },
  {
    path: 'RedisCacheManagement',
    component: RedisCacheManagementComponent,
    canActivate: [InternalAdminViewRouteGuardService],
    data: {
      title: 'Redis Cache Management'
    }
  },
  {
    matcher: publicationRouteMatcher,
    canActivate: [RouteGaurdService],
    loadChildren: () => import('./modules/publication/publication.module').then(m => m.PublicationModule)
  },

  { path: '**', redirectTo: 'Login', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }




